export default __webpack_public_path__ + "static/media/grp.c5f47044.jpg";